export default "__VITE_ASSET__dXYzcVLE__"